/* PureMg scroll reveal JS */
document.addEventListener('DOMContentLoaded', function() {
  var sections = document.querySelectorAll('.shopify-section:not(:first-child)');
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('puremg-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  sections.forEach(function(s) { observer.observe(s); });
});
